import { defaultStates } from './defaultStates';
import { CaseWorker } from './getters';

export const setSession = (state, session) => {
  state.session = session;
};

export const setGuestToken = (state, GuestToken) => {
  state.GuestToken = GuestToken;
};

export const setAccount = (state, Account) => {
  state.Account = Account;
};

export const setChild = (state, Child) => {
  state.Child = Child;
};

export const setAgency = (state, Agency) => {
  state.Agency = Agency;
};

export const setCaseWorker = (state, CaseWorker) => {
  state.CaseWorker = CaseWorker;
};

export const setDefaultAgency = (state, DefaultAgency) => {
  state.DefaultAgency = DefaultAgency;
};

export const setMyFamilies = (state, MyFamilies) => {
  state.MyFamilies = MyFamilies;
};

export const setMyChildren = (state, MyChildren) => {
  state.MyChildren = MyChildren;
};

export const setJSONData = (state, JSONData) => {
  state.JSONData = JSONData;
};

export const setChildrenJSONData = (state, ChildrenJSONData) => {
  state.ChildrenJSONData = ChildrenJSONData;
};

export const setDashboardFamilies = (state, DashboardFamilies) => {
  state.DashboardFamilies = DashboardFamilies;
};

export const setDashboardFamiliesLoaded = (state, DashboardFamiliesLoaded) => {
  state.DashboardFamiliesLoaded = DashboardFamiliesLoaded;
};

export const setAgencyList = (state, AgencyList) => {
  state.AgencyList = AgencyList;
};

export const setAgenciesRequiredPayment = (state, AgenciesRequiredPayment) => {
  state.AgenciesRequiredPayment = AgenciesRequiredPayment;
};

export const setCountry = (state, Country) => {
  state.Country = Country;
};

export const setState = (state, State) => {
  state.State = State;
};

export const setVideo = (state, Video) => {
  state.Video = Video;
};

export const setBlog = (state, Blog) => {
  state.Blog = Blog;
};

export const setLetter = (state, Letter) => {
  state.Letter = Letter;
};

export const setAlbum = (state, Album) => {
  state.Album = Album;
};

export const setAlbumPhotosPopulated = (state, AlbumPhotosPopulated) => {
  state.AlbumPhotosPopulated = AlbumPhotosPopulated;
};

export const setAlbumLoaded = (state, AlbumLoaded) => {
  state.AlbumLoaded = AlbumLoaded;
};

export const setAlbumPhoto = (state, AlbumPhoto) => {
  state.AlbumPhoto = AlbumPhoto;
};

export const setProfileDocument = (state, ProfileDocument) => {
  state.ProfileDocument = ProfileDocument;
};

export const setProfileDocumentList = (state, ProfileDocumentList) => {
  state.ProfileDocumentList = ProfileDocumentList;
};

export const setProfileDocConversation = (state, ProfileDocConversation) => {
  state.ProfileDocConversation = ProfileDocConversation;
};

export const setPhotoDownload = (state, PhotoDownload) => {
  state.PhotoDownload = PhotoDownload;
};

export const setRequest = (state, Request) => {
  state.Request = Request;
};

export const setTemplate = (state, Template) => {
  state.Template = Template;
};

export const setTemplateItem = (state, TemplateItem) => {
  state.TemplateItem = TemplateItem;
};

export const setTemplateArray = (state, TemplateArray) => {
  state.TemplateArray = TemplateArray;
};

export const setFile = (state, File) => {
  state.File = File;
};

export const setFileLoaded = (state, FileLoaded) => {
  state.FileLoaded = FileLoaded;
};

export const setTask = (state, Task) => {
  state.Task = Task;
};

export const setTimeline = (state, Timeline) => {
  state.Timeline = Timeline;
};

export const setTimelineLoaded = (state, TimelineLoaded) => {
  state.TimelineLoaded = TimelineLoaded;
};

export const setIsSubscriptionActive = (state, IsSubscriptionActive) => {
  state.IsSubscriptionActive = IsSubscriptionActive;
};

export const setIsSubscriptionActiveLoaded = (state, IsSubscriptionActiveLoaded) => {
  state.IsSubscriptionActiveLoaded = IsSubscriptionActiveLoaded;
};

export const setPdfTemplate = (state, PdfTemplate) => {
  state.PdfTemplate = PdfTemplate;
};

export const setPdfTemplateLoaded = (state, PdfTemplateLoaded) => {
  state.PdfTemplateLoaded = PdfTemplateLoaded;
};

export const setMessage = (state, Message) => {
  state.Message = Message;
};

export const setMessageLoaded = (state, MessageLoaded) => {
  state.MessageLoaded = MessageLoaded;
};

export const setCountsLoaded = (state, CountsLoaded) => {
  state.CountsLoaded = CountsLoaded;
};

export const setAuthorizeTransactionReport = (state, AuthorizeTransactionReport) => {
  state.AuthorizeTransactionReport = AuthorizeTransactionReport;
};

export const setAuthorizeNetFutureTransaction = (state, AuthorizeNetFutureTransaction) => {
  state.AuthorizeNetFutureTransaction = AuthorizeNetFutureTransaction;
};

export const setMessageGroup = (state, MessageGroup) => {
  state.MessageGroup = MessageGroup;
};

export const setConversation = (state, Conversation) => {
  state.Conversation = Conversation;
};

export const setArchiveConversation = (state, ArchiveConversation) => {
  state.ArchiveConversation = ArchiveConversation;
};

export const setConversationLoaded = (state, ConversationLoaded) => {
  state.ConversationLoaded = ConversationLoaded;
};

export const setAllAccount = (state, AllAccount) => {
  state.AllAccount = AllAccount;
};

export const setContactList = (state, ContactList) => {
  state.ContactList = ContactList;
};

export const setHuman = (state, Human) => {
  state.Human = Human;
};

export const setBlogCategory = (state, BlogCategory) => {
  state.BlogCategory = BlogCategory;
};

export const setBlogSettings = (state, BlogSettings) => {
  state.BlogSettings = BlogSettings;
};

export const setVideoList = (state, VideoList) => {
  state.VideoList = VideoList;
};

export const setHelpVideoLoaded = (state, HelpVideoLoaded) => {
  state.HelpVideoLoaded = HelpVideoLoaded;
};

export const setFeedback = (state, Feedback) => {
  state.Feedback = Feedback;
};

export const setFaq = (state, Faq) => {
  state.Faq = Faq;
};

export const setFaqLoaded = (state, FaqLoaded) => {
  state.FaqLoaded = FaqLoaded;
};

export const setAdminDashboardCounts = (state, AdminDashboardCounts) => {
  state.AdminDashboardCounts = AdminDashboardCounts;
};

export const setMyAgencies = (state, MyAgencies) => {
  state.MyAgencies = MyAgencies;
};

export const setSurvey = (state, Survey) => {
  state.Survey = Survey;
};

export const setSurveyLoaded = (state, SurveyLoaded) => {
  state.SurveyLoaded = SurveyLoaded;
};

export const setSurveyCount = (state, SurveyCount) => {
  state.SurveyCount = SurveyCount;
};

export const setClientDomains = (state, ClientDomains) => {
  state.ClientDomains = ClientDomains;
};

export const setEmailTemplate = (state, EmailTemplate) => {
  state.EmailTemplate = EmailTemplate;
};

export const setWebsiteTemplate = (state, WebsiteTemplate) => {
  state.WebsiteTemplate = WebsiteTemplate;
};

export const setGoogleAd = (state, GoogleAd) => {
  state.GoogleAd = GoogleAd;
};

export const setGroupCampaign = (state, GroupCampaign) => {
  state.GroupCampaign = GroupCampaign;
};

export const setCampaign = (state, Campaign) => {
  state.Campaign = Campaign;
};

export const setCampaignReport = (state, CampaignReport) => {
  state.CampaignReport = CampaignReport;
};

export const setCampaignDetailedReport = (state, CampaignDetailedReport) => {
  state.CampaignDetailedReport = CampaignDetailedReport;
};

export const setDataUpdateRequest = (state, DataUpdateRequest) => {
  state.DataUpdateRequest = DataUpdateRequest;
};

export const setMenuSettings = (state, MenuSettings) => {
  state.MenuSettings = MenuSettings;
};

export const setPaymentMode = (state, PaymentMode) => {
  state.PaymentMode = PaymentMode;
};

export const resetStates = (state) => {

  Object.keys(defaultStates).forEach(key => {
    state[key] = defaultStates[key];
  });
  
};

export const setActivity = (state, Activity) => {
  state.Activity = Activity;
};

export const setProject = (state, Project) => {
  state.Project = Project;
};

export const setAllProject = (state, AllProject) => {
  state.AllProject = AllProject;
};

export const setLog = (state, Log) => {
  state.Log = Log;
};

export const setSearchResult = (state, SearchResult) => {
  state.SearchResult = SearchResult;
};

export const setFileCategory = (state, FileCategory) => {
  state.FileCategory = FileCategory;
};

export const setDocumentList = (state, DocumentList) => {
  state.DocumentList = DocumentList;
};

export const setAdminList = (state, AdminList) => {
  state.AdminList = AdminList;
};

export const setHelpFileList = (state, HelpFileList) => {
  state.HelpFileList = HelpFileList;
};

export const setMusic = (state, Music) => {
  state.Music = Music;
};

export const setAppVersionList = (state, appVersionList) => {
  state.appVersionList = appVersionList;
};

export const setBadgeContact = (state, BadgeContact) => {
  state.BadgeContact = BadgeContact;
};

export const setAgencyAccount = (state, AgencyAccount) => {
  state.AgencyAccount = AgencyAccount;
};

export const setChildGroup = (state, ChildGroup) => {
  state.ChildGroup = ChildGroup;
};


// WEBPACK FOOTER //
// ./src/store/mutations.js